<div class="attachments-container" [class]="classList">

  <!-- Galeria adjuntos -->
  <div *ngIf="files?.length" class="attachments-module">
    <web-attachments-module [attachments]="files" order="asc" [showTitle]="showTitles" [classList]="classList"
      title="{{ 'general.attachmentsGallery' | translate }}">
    </web-attachments-module>
  </div>

  <div class="multimedia-container">

    <!-- Galeria imagenes -->
    <web-images-module *ngIf="images?.length" [images]="images" order="asc" [showTitle]="showTitles"
      [classList]="classList" title="{{ 'general.imagesGallery' | translate }}">
    </web-images-module>


    <!-- Galeria vídeos -->
    <web-videos-module *ngIf="videos?.length" [videos]="videos" order="asc" [showTitle]="showTitles"
      [classList]="classList" title="{{ 'general.videosGallery' | translate }}">
    </web-videos-module>

  </div>

</div>